<template>
<v-row row wrap>
  <v-col cols=12 >
    <v-toolbar >
      <v-btn icon small
        :loading='requests.spaces.loading'
        @click='get' ><v-icon small >mdi-reload</v-icon></v-btn>
      <v-divider vertical />
      <v-toolbar-title class='ml-2' >Spaces</v-toolbar-title>
      <v-chip label x-small class='ml-3' >managed by me</v-chip>
      <v-spacer></v-spacer>
      <!-- <v-switch v-model='showArchived' label='show archived' class='mt-5' dense /> -->
      <!-- @click='launchNewSpaceWizard' -->
      <!-- <v-btn outlined
        v-if='spacesIOwn && spacesIOwn.length > 1'
        to='/wizards/converge'
        class='ml-3' color='primary' >
        <v-icon class='mr-2' >mdi-call-merge</v-icon>
        Merge Spaces
      </v-btn> -->
      <v-btn
        @click="launchNewSpaceWizard"
        class='ml-3' color='primary' >
        <v-icon class='mr-2' >mdi-plus</v-icon>
        New Space
      </v-btn>
    </v-toolbar>
    <request-status :request="requests.spaces" />
  </v-col>
  <v-col cols=12 sm=6 md=6 lg=6 xl=3 >
    <v-hover v-slot="{ hover }" >
      <practitioner-card dark
        v-if='meId' :id='meId'
        :cta='practitionerCTA'
        :attrs="{height: '100%', elevation: hover ? 16 : 5 }" />
    </v-hover>
  </v-col>

  <v-col
    v-if="requests.spaces.loading"
    cols=12 sm=6 md=6 lg=6 xl=3 >
    <v-skeleton-loader
      class="mx-auto"
      type="card-avatar, article, actions" />
  </v-col>
  <template v-for='(space, index) in spaces' >
    <v-col v-if='isOwner(space)' :key='space.id'
      cols=12 sm=6 md=6 lg=6 xl=3 >
      <v-hover v-slot="{ hover }" >
        <!-- :cta='getSpaceCta(space)' -->
        <space-card
          v-model='spaces[index]'
          :flat='false'
          :cta='getSpaceCta(space)'
          :attrs="{height: '100%', elevation: hover ? 16 : 5 }" />
      </v-hover>
    </v-col>

  </template>

  <v-col
    v-if="(spaces && spaces.length === 0 && requests.spaces.loading !== true)"
    cols=12 sm=6 md=6 lg=6 xl=3 >
    <v-card class='new-space-card elevation-10' height='100%' @click='launchNewSpaceWizard' >
      <v-img
        src='https://ik.imagekit.io/appointmentguru/dropbox/Screenshot_2021-07-22_at_23.48.45.png?updatedAt=1627005119638&tr=h-400,fo-auto' />
      <v-divider/>
      <v-overlay :value='true' absolute >
        <v-card-title
          class='subtitle-1 overline justify-center' >
            <v-avatar size='150' class='mb-3 mt-5 elevation-10' color='info' >
              <v-icon style='font-size:70px' class='white--text' >mdi-plus</v-icon>
            </v-avatar>
        </v-card-title>
        <v-card-text class='text-h5 text-center' >
          Create a space for your business or a practice
        </v-card-text>
      </v-overlay>
    </v-card>
  </v-col>

  <v-col v-show='false' cols=12 sm=6 md=6 lg=4 xl=3 >
    <v-hover v-slot="{ hover }" >
      <onboarder
        :attrs="{height: '100%', elevation: hover ? 16 : 5 }" />
    </v-hover>
  </v-col>
  <template v-if='memberSpaces && memberSpaces.length > 0' >
    <v-col cols="12" >
      <h3>Other Spaces. <small>(Spaces you are a member of)</small></h3>
      <!-- {{memberSpaces}} -->
    </v-col>
    <v-col v-for='space in memberSpaces' :key='`member-${space.id}`' cols=12 sm=6 md=6 lg=6 xl=3 >

      <v-list height='100%' class='elevation-5' >
        <space-list-item :item='space' />
      </v-list>

    </v-col>
  </template>

  <template v-if='archivedSpaces && archivedSpaces.length > 0' >
    <v-col cols="12" >
      <h3>Archived spaces.<small></small></h3>
    </v-col>
    <v-col
      v-for='space in archivedSpaces'
      :key='`member-${space.id}`'
      cols=12 sm=6 md=6 lg=6 xl=3 >
      <!-- <pre v-text='space' /> -->
      <v-list height='100%' class='elevation-5' >
        <space-list-item :item='space' >
          <!-- todo -->
          <template slot='list-item-action' >
            <v-list-item-action >
              <v-btn text
                :loading='requests.restore.loading'
                @click='restoreSpace(space.id)' >Restore</v-btn>
            </v-list-item-action>
            <v-list-item-action >
              <v-btn color='error' @click='spaceToDelete=space;confirmDeleteDialog=true' >
                Delete
              </v-btn>
            </v-list-item-action>
          </template>
        </space-list-item>
      </v-list>
    </v-col>
  </template>

  <v-dialog v-model='confirmDeleteDialog' width='500' >
    <v-card v-if='spaceToDelete && spaceToDelete.id' >
      <request-status :request='requests.archive' />
      <v-card-title class='overline' >
        Please confirm
        <v-spacer/>
        <v-btn icon @click='confirmDeleteDialog=false' ><v-icon>mdi-close</v-icon></v-btn>
      </v-card-title>
      <v-card-text>
        Are you sure you want to permanently delete this space
        <v-subheader class="pl-0 overline" >Space information</v-subheader>
        {{spaceToDelete.title}}
      </v-card-text>
      <v-alert tile text dense
          type='warning' >This action is not undoable</v-alert>
      <v-card-actions>
        <v-btn @click='confirmDeleteDialog=false' text >Cancel</v-btn>
        <v-spacer/>
        <v-btn
          @click='deleteSpace(spaceToDelete.id)'
          :loading='requests.delete.loading'
          color='error' >Delete</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</v-row>
</template>
<script>
import SpaceCard from '@/components/cards/SpaceCard'
import SpaceListItem from '@/components/listitems/SpaceListItem.vue'
import PractitionerCard from '@/components/cards/PractitionerCard'
import Onboarder from '@/components/Onboarder/index.vue'

import {mapGetters} from 'vuex'

export default {
  name: 'SpacesHome',
  components: {
    SpaceCard, SpaceListItem, PractitionerCard, Onboarder
  },
  // props: {
  //   spaceId: { required: true }
  // },
  data () {
    return {
      activeTab: 0,
      showArchived: false,
      confirmDeleteDialog: false,
      practitionerCTA: {
        link: '/settings/me/profile',
        text: 'Profile',
        color: 'success'
      },
      spaceToDelete: null,
      requests: {
        spaces: {
          resource: 'ag.spaces.practitioner',
          loading: false,
          status: 0,
          result: {}
        },
        delete: {
          resource: 'ag.spaces.practitioner'
        },
        restore: {
          resource: 'ag.spaces.practitioner',
          extra: 'actions/restore_space',
          method: 'post'
        }
      }
    }
  },
  mounted () {
    this.get()
  },
  methods: {
    get () {
      this.$request('get', this.requests.spaces)
    },
    isOwner (space) {
      let me = space.service_practitioners.find((p) => {
        return p.practitioner === this.meId
      })
      if (me) { return me.role === "Owner" }
    },
    getSpaceCta (space) {
      return {
        link: '/brand/' + space.id,
        color: 'amber',
        text: 'See the brand',
        icon: 'mdi-star-shooting'
      }
    },
    restoreSpace (spaceId) {
      this.requests.restore.resourceId = spaceId
      this.$request('save', this.requests.restore)
    },
    archiveSpace (spaceId) {
      this.requests.delete.resourceId = spaceId
      this.requests.delete.params = {action: 'archive'}
      this.$request('delete', this.requests.delete)
    },
    deleteSpace (spaceId) {
      this.requests.delete.resourceId = spaceId
      this.requests.delete.params = {action: 'delete'}
      this.$request('delete', this.requests.delete)
    }
  },
  watch: {
    spacesList () { this.get() },
    restoreRequestStatus () {
      if (this.restoreRequestStatus === 200) { this.get() }
    },
    deleteRequestStatus () {
      if (this.deleteRequestStatus === 204) {
        this.get()
        this.confirmDeleteDialog = false
      }
    }
  },
  computed: {
    ...mapGetters('identity', [
      'businesses',
      'meId',
      'spacesList',
      'spacesIOwn'
    ]),
    url () {
      return process.env.VUE_APP_APPOINTMENTGURU_API_ROOT
    },
    restoreRequestStatus () {
      return this.requests.restore.status
    },
    deleteRequestStatus () {
      return this.requests.delete.status
    },
    memberSpaces () {
      let spaces = this.getObjectPath(this.requests.spaces, 'result.results', [])
      let meId = this.meId
      return spaces.filter((space) => {
        if (space.service_practitioners) {
          let me = space.service_practitioners.find((p) => {
            return (parseInt(meId) === parseInt(p.practitioner))
          })
          if (me && me.role === "Member") {
            return space
          }
        }
      })
    },
    archivedSpaces () {
      let spaces = this.getObjectPath(this.requests.spaces, 'result.results', [])
      return spaces.filter((space) => {
        return space.archived
      })
    },
    spaces () {
      let spaces = this.getObjectPath(this.requests.spaces, 'result.results', [])
      if (this.showArchived === true) {
        return spaces
      } else {
        return spaces.filter((space) => { return space.archived === false})
      }
    },
    businessId () {
      if (this.businesses && this.businesses.length > 0) {
        return this.businesses[0].id
      }
      return null
    }
  }
}
</script>
